import {FetcherMiddleware} from "../../core/network/fetcher/Fetcher";
import {AppStateAccountData} from "../../wallet/account/accountTypes";
import {AssetListItemData} from "../util/assetModels";
import {
  canAssetBeUsedAsPoolConstituent,
  isNonLiquidAsset,
  mapAssetToAssetListItemData
} from "../util/assetUtils";

function mapAssetToAssetListItemDataMiddleware(
  account: null | AppStateAccountData,
  accountAssets: AssetListItemData[]
): FetcherMiddleware<ListRequestResponse<AssetListItemData>> {
  return (response) => {
    return Promise.resolve({
      ...response,
      results: response.results.map(mapAssetToAssetListItemData(account, accountAssets))
    });
  };
}

function filterOutNonLiquidAssetsMiddleware(): FetcherMiddleware<
  ListRequestResponse<AssetListItemData>
> {
  return (response) => {
    const liquidAssets = response.results.filter((asset) => !isNonLiquidAsset(asset));

    return Promise.resolve({
      ...response,
      results: liquidAssets
    });
  };
}

function filterInAssetsThatCanBePoolConstituentMiddleware(): FetcherMiddleware<
  ListRequestResponse<AssetListItemData>
> {
  return (response) => {
    return Promise.resolve({
      ...response,
      results: response.results.filter(canAssetBeUsedAsPoolConstituent)
    });
  };
}

export {
  mapAssetToAssetListItemDataMiddleware,
  filterOutNonLiquidAssetsMiddleware,
  filterInAssetsThatCanBePoolConstituentMiddleware
};
